export default __webpack_public_path__ + "static/media/contacts.1f85b150.svg";